module.exports = __webpack_public_path__ + "img/forgot-password-v2.02fa1b45.svg";